<style scoped lang="scss" type="text/scss">
    .special-award-container {
        overflow: auto;

        .special-award-wrap {
            display: flex;
            flex-wrap: wrap;
            margin: -1rem 0 0 -1rem;

            .special-award-item {
                width: calc(50% - 1rem);
                height: 14rem;
                margin: 1rem 0 0 1rem;
            }
        }
    }

    @media screen and (min-width: 95rem) {
        .special-award-item {
            width: calc(33.3% - 1rem) !important;
        }
    }
</style>

<template>
    <div class="special-award-container" :style="{'max-height': visualAreaHeight}">
        <div class="special-award-wrap">
            <add-block reversed class="special-award-item" title="个人单项奖" @click.native="showEditor"></add-block>
            <special-award-item class="special-award-item"
                                v-for="(award, index) in awards" :key="index"
                                type="player-member" :info="award"
                                @call-edit="showUpdateEditor(award.id, ...arguments)"
                                @call-remove="remove(award.id, ...arguments)"
            >
            </special-award-item>
        </div>

        <popup :visible.sync="isEditorVisible"
               :is-update="isUpdateMode"
               :id="updateId"
               :deletable="isUpdateMode"
               @need-reload="loadAwards"
        >
        </popup>
    </div>
</template>

<script>
    import AddBlock from '../../../../../../../components/add-block/index';
    import SpecialAwardItem from '../special-award-item';
    import Popup from './popup';
    import {handleSpecialPlayerMemberAwards} from '../../../../../../../utils/data-handler';

    export default {
        name: '',
        components: {
            AddBlock,
            SpecialAwardItem,
            Popup
        },
        data () {
            return {
                awards: [],
                isEditorVisible: false,
                isUpdateMode: false,
                keyword: null,
                updateId: null
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            visualAreaHeight () {
                return this.$store.getters['layout/adminSpecialAwardVisualAreaHeight'] + 'px';
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler (currentCompetitionId) {
                    if (currentCompetitionId === null || currentCompetitionId === undefined) return;
                    this.loadAwards();
                }
            }
        },
        methods: {
            showEditor () {
                this.updateId = null;
                this.isUpdateMode = false;
                this.isEditorVisible = true;
            },
            showUpdateEditor (id, callback) {
                this.updateId = id;
                this.isUpdateMode = true;
                this.isEditorVisible = true;
                callback();
            },
            remove (id, callback) {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('competition/deleteSpecialPlayerMemberAward', {
                        competition_special_award_id: id
                    }, '删除成功').then(_ => {
                        this.loadAwards().then(_ => {
                            callback();
                        });
                    }).catch(_ => {
                        callback();
                    });
                }).catch(_ => {
                    callback();
                });
            },
            loadAwards () {
                return this.$store.dispatch('competition/loadSpecialPlayerMemberAwards', {
                    competition_id: this.currentCompetitionId
                }).then(response => {
                    this.awards = handleSpecialPlayerMemberAwards(response.data);
                });
            }
        }
    };
</script>
